import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.LSError', this, 4);
        tmp0_serialDesc.a1b('http', false);
        tmp0_serialDesc.a1b('detail', true);
        tmp0_serialDesc.a1b('message', true);
        tmp0_serialDesc.a1b('data', true);
        this.m4b_1 = tmp0_serialDesc;
      }
      n4b(encoder, value) {
        var tmp0_desc = this.m4b_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.v14(tmp0_desc, 0, value.o4b_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.p4b_1 === '')) {
          tmp1_output.a15(tmp0_desc, 1, value.p4b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.q4b_1 === '')) {
          tmp1_output.a15(tmp0_desc, 2, value.q4b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.r4b_1 === '')) {
          tmp1_output.a15(tmp0_desc, 3, value.r4b_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.n4b(encoder, value instanceof LSError() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m4b_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.q13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.q13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return LSError().s4b(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.m4b_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var LSErrorClass;
function LSError() {
  if (LSErrorClass === VOID) {
    class $ {
      constructor(http, detail, message, data) {
        detail = detail === VOID ? '' : detail;
        message = message === VOID ? '' : message;
        data = data === VOID ? '' : data;
        this.o4b_1 = http;
        this.p4b_1 = detail;
        this.q4b_1 = message;
        this.r4b_1 = data;
      }
      toString() {
        return 'LSError(http=' + this.o4b_1 + ', detail=' + this.p4b_1 + ', message=' + this.q4b_1 + ', data=' + this.r4b_1 + ')';
      }
      hashCode() {
        var result = this.o4b_1;
        result = imul(result, 31) + getStringHashCode(this.p4b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q4b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r4b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LSError()))
          return false;
        if (!(this.o4b_1 === other.o4b_1))
          return false;
        if (!(this.p4b_1 === other.p4b_1))
          return false;
        if (!(this.q4b_1 === other.q4b_1))
          return false;
        if (!(this.r4b_1 === other.r4b_1))
          return false;
        return true;
      }
      static s4b(seen0, http, detail, message, data, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().m4b_1);
        }
        var $this = createThis(this);
        $this.o4b_1 = http;
        if (0 === (seen0 & 2))
          $this.p4b_1 = '';
        else
          $this.p4b_1 = detail;
        if (0 === (seen0 & 4))
          $this.q4b_1 = '';
        else
          $this.q4b_1 = message;
        if (0 === (seen0 & 8))
          $this.r4b_1 = '';
        else
          $this.r4b_1 = data;
        return $this;
      }
    }
    initMetadataForClass($, 'LSError', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    LSErrorClass = $;
  }
  return LSErrorClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  LSError as LSError2xrpo13ez2d1,
  $serializer_getInstance as $serializer_getInstance3d2qec0zxd66,
  Companion_instance as Companion_instancei6s1qtvf2v72,
};
//endregion

//# sourceMappingURL=LSError.mjs.map
